export default {
    cms: {
        category: 'cms',
        permissions: {
            edit_values: 'edit values',
        },
    },
};
